<template>
  <g
    v-if="$root.$data.plugModeSaka === true"
    :transform="(flip === true ? `scale(-1 1) translate(-${ 2 * x} 0)`: '')"
  >
    <!-- Ferrule -->
    <circle r="3" :cx="x" :cy="y" fill="#e0e0e0"/>
    <line :x1="x" :x2="x+25" :y1="y" :y2="y" fill="#e0e0e0" stroke="#e0e0e0" stroke-width="6"/>
    <rect fill="#d1d1d1" :x="x + 20" :height="12" :y="y - 12 / 2" :width="plugWidth"/>
    <rect
      :fill="getColor(plugColor)"
      :x="x + 20 + plugWidth"
      :height="10"
      :y="y - 10 / 2"
      :width="plugWidth / 2"
    />
  </g>
  <g
    v-else
    :transform="(flip === true ? `scale(-.8 .8) translate(-${x/.8 + 8} ${y/.85 + 15}) rotate(-90)` : `scale(.8 .8) translate(${x/.8 - 8} ${y/.85 + 15}) rotate(-90)`)"
    stroke="white"
  >
    <rect x="0" y="0" width="19" height="76" fill="white"/>
    <rect :fill="getColor(plugColor)" x="2.5" y="75.5" width="16" height="3"/>
    <rect :fill="getColor(plugColor)" x="2.5" y="64.5" width="16" height="11"/>
    <rect :fill="getColor(plugColor)" x="0.5" y="40.5" width="20" height="24" rx="2"/>
    <rect :fill="getColor(plugColor)" x="0.5" y="40.5" width="20" height="24" rx="2"/>
    <rect :fill="getColor(plugColor)" x="4.5" y="28.5" width="12" height="8"/>
    <rect :fill="getColor(plugColor)" x="3.5" y="36.5" width="14" height="4"/>
    <path fill="#d2d2d2" d="M10.5.5a3,3,0,0,0-3,3v25h6V3.5A3,3,0,0,0,10.5.5Z"/>
    <line stroke="white" x1="3" y1="40.5" x2="3" y2="64.5"/>
    <line stroke="white" x1="6" y1="40.5" x2="6" y2="64.5"/>
    <line stroke="white" x1="9" y1="40.5" x2="9" y2="64.5"/>
    <line stroke="white" x1="12" y1="40.5" x2="12" y2="64.5"/>
    <line stroke="white" x1="15" y1="40.5" x2="15" y2="64.5"/>
    <line stroke="white" x1="18" y1="40.5" x2="18" y2="64.5"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 25,
      plugHeight: 10
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color () {
      return this.getColor(this.plugColor)
    },
    yRecalculated () {
      return this.y - this.plugHeight / 2
    }
  },
  methods: {
    getColor(colorName) {
      return this.getCssColor(colorName);
    },
    getNoseColor: colorName => {
      return this.getCssColor(colorName + "Nase");
    }
  }
}
</script>

<style>
.ferrule {
  fill: #e0e0e0;
}
